import React, { useCallback, useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { Button } from 'reactstrap';

function AsyncButton({
  children,
  onClick,
  disabled,
  className,
  ...otherProps
}) {
  const [loading, setLoading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const handleClick = useCallback(
    (e) => {
      if (onClick && !disabled && !loading) {
        setLoading(true);
        const res = onClick(e);
        if (res && res.finally) {
          res.finally(() => mounted.current && setLoading(false));
        } else {
          setLoading(false);
        }
      }
    },
    [setLoading, disabled, loading, onClick]
  );
  return (
    <Button
      {...otherProps}
      className={cx('btn-async', className, {
        'btn-async-loading': loading,
      })}
      disabled={!!disabled || loading}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
}

export default AsyncButton;
